<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>{{ (type$ | async)?.name }}</glxy-page-title>
    <glxy-page-actions>
      <a [routerLink]="'/loop'">
        <button mat-stroked-button>Cancel</button>
      </a>
      <button mat-raised-button color="primary" (click)="save()" [disabled]="(templatesLoaded$ | async) === false">
        Save
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <form [formGroup]="form" *ngIf="type$ | async as type; else loading">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>General</mat-panel-title>
            <mat-panel-description> General post type settings. </mat-panel-description>
          </mat-expansion-panel-header>
          <app-loop-post-type-general-settings [parentForm]="form" />
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Filters</mat-panel-title>
            <mat-panel-description> Settings for the filters available to a post type </mat-panel-description>
          </mat-expansion-panel-header>
          <app-loop-post-type-filter-settings [parentForm]="form" />
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Icons</mat-panel-title>
            <mat-panel-description>
              Settings for the icons that are displayed alongside posts of this type.
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-loop-post-type-icon-settings [parentForm]="form" />
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Templates</mat-panel-title>
            <mat-panel-description>
              Settings for the templates used to display posts in the Loop
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-loop-post-type-templates-settings
            [parentForm]="form"
            [templateId]="type.templateId"
            (loaded)="setTemplatesLoaded()"
          />
        </mat-expansion-panel>
      </mat-accordion>
      <!-- TODO: Show event data structure and hydration data structures somewhere on this page to make it easier to choose variables  -->
    </form>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #loading>
  <div class="center">
    <mat-spinner diameter="24" />
  </div>
</ng-template>
